// Privacy Policy content (provided by the client - verbatim).
export const PRIVACY = {
  updated: "Última actualización: 31 de agosto de 2026",
  intro: [
    "En RSV TRANSFERS nos comprometemos a proteger la privacidad y los datos personales de nuestros clientes, pasajeros y usuarios.",
    "La presente Política de Privacidad y Aviso de Privacidad explica qué información podemos recopilar, para qué la utilizamos, con quién podemos compartirla, durante cuánto tiempo podemos conservarla y qué derechos tienen los titulares respecto de sus datos personales.",
    "Al utilizar nuestro sitio web, solicitar una cotización, realizar una reservación, contratar nuestros servicios o proporcionarnos información a través de nuestros diferentes canales de comunicación, el usuario reconoce haber tenido acceso a esta Política de Privacidad.",
  ],
  sections: [
    {
      title: "RESPONSABLE DEL TRATAMIENTO DE DATOS",
      content: [
        { type: "p", text: "El responsable del tratamiento de los datos personales es:" },
        { type: "ul", items: [
          "RESERVACION CANCUN LLC",
          "Nombre comercial: RSV TRANSFERS",
          "Domicilio: 30 N Gould St Ste N, Sheridan, WY 82801, Estados Unidos",
          "Correo electrónico: contact@rsvcancun.com",
          "Teléfono: +52 998 790 7699",
          "Sitio web: rsvcancun.com",
        ]},
        { type: "p", text: "RESERVACION CANCUN LLC opera comercialmente bajo la marca RSV TRANSFERS y presta servicios de transportación privada y turística de pasajeros, principalmente en Cancún, Riviera Maya y otros destinos dentro de nuestra cobertura." },
      ],
    },
    {
      title: "DATOS PERSONALES QUE PODEMOS RECOPILAR",
      content: [
        { type: "p", text: "Dependiendo de la forma en que el usuario interactúe con RSV TRANSFERS y del servicio solicitado, podremos recopilar las siguientes categorías de información:" },
        { type: "sub", text: "Datos de identificación" },
        { type: "ul", items: [
          "Nombre y apellidos.",
          "Nombre del titular de la reservación.",
          "Información necesaria para identificar la reservación.",
        ]},
        { type: "sub", text: "Datos de contacto" },
        { type: "ul", items: [
          "Correo electrónico.",
          "Número telefónico.",
          "Número de WhatsApp u otros medios de comunicación proporcionados voluntariamente por el usuario.",
        ]},
        { type: "sub", text: "Datos relacionados con la reservación" },
        { type: "ul", items: [
          "Fecha del servicio.",
          "Horario del servicio.",
          "Lugar de recogida.",
          "Destino.",
          "Hotel o alojamiento.",
          "Número de pasajeros.",
          "Tipo de servicio solicitado.",
          "Tipo de vehículo solicitado o asignado.",
          "Información de llegada o salida.",
          "Solicitudes especiales relacionadas con el servicio.",
        ]},
        { type: "sub", text: "Información de vuelos" },
        { type: "p", text: "Cuando el servicio esté relacionado con un traslado desde o hacia un aeropuerto podremos recopilar:" },
        { type: "ul", items: [
          "Aerolínea.",
          "Número de vuelo.",
          "Aeropuerto.",
          "Horario programado de llegada o salida.",
          "Información relacionada con cambios o retrasos del vuelo cuando resulte necesaria para coordinar el servicio.",
        ]},
        { type: "sub", text: "Datos relacionados con pagos" },
        { type: "p", text: "Cuando el usuario realiza una reservación de pago, podremos tratar información relacionada con la operación, incluyendo:" },
        { type: "ul", items: [
          "Nombre del titular del pago.",
          "Importe.",
          "Moneda.",
          "Fecha de la transacción.",
          "Identificador o referencia de la operación.",
          "Estado del pago.",
          "Información necesaria para prevenir fraude, contracargos o transacciones no autorizadas.",
        ]},
        { type: "p", text: "RSV TRANSFERS podrá utilizar proveedores externos especializados para procesar pagos." },
        { type: "p", text: "Cuando el pago sea procesado directamente por un proveedor externo, RSV TRANSFERS no necesariamente recibe ni almacena los datos completos de la tarjeta bancaria, como el número completo de tarjeta o código de seguridad (CVV)." },
        { type: "p", text: "Dicha información puede ser procesada directamente por el proveedor de servicios de pago correspondiente conforme a sus propias políticas de privacidad y estándares de seguridad." },
        { type: "sub", text: "Información técnica" },
        { type: "p", text: "Cuando el usuario visita nuestro sitio web podremos recopilar automáticamente determinada información técnica, dependiendo de las tecnologías utilizadas, incluyendo:" },
        { type: "ul", items: [
          "Dirección IP.",
          "Tipo de navegador.",
          "Tipo de dispositivo.",
          "Sistema operativo.",
          "Fecha y hora de acceso.",
          "Páginas visitadas.",
          "Información de navegación.",
          "Cookies y tecnologías similares.",
        ]},
      ],
    },
    {
      title: "DATOS PERSONALES SENSIBLES",
      content: [
        { type: "p", text: "RSV TRANSFERS no solicita de manera habitual datos personales sensibles para la prestación ordinaria de servicios de transportación." },
        { type: "p", text: "Solicitamos a nuestros usuarios no proporcionar información sensible que no resulte necesaria para la prestación del servicio." },
        { type: "p", text: "Cuando por circunstancias particulares resulte estrictamente necesario tratar información que legalmente sea considerada sensible, se adoptarán las medidas y mecanismos de consentimiento que correspondan conforme a la legislación aplicable." },
      ],
    },
    {
      title: "FINALIDADES DEL TRATAMIENTO",
      content: [
        { type: "p", text: "Los datos personales podrán ser utilizados para las siguientes finalidades principales:" },
        { type: "ul", items: [
          "Gestionar solicitudes de información.",
          "Elaborar cotizaciones.",
          "Crear y administrar reservaciones.",
          "Confirmar servicios de transportación.",
          "Procesar y verificar pagos.",
          "Coordinar horarios, vehículos, conductores y puntos de encuentro.",
          "Coordinar servicios desde o hacia aeropuertos.",
          "Dar seguimiento a vuelos cuando resulte necesario.",
          "Comunicarnos con el pasajero antes, durante o después del servicio.",
          "Informar cambios relacionados con una reservación.",
          "Atender solicitudes, aclaraciones o reclamaciones.",
          "Prevenir operaciones fraudulentas.",
          "Gestionar disputas de pagos y contracargos.",
          "Mantener registros administrativos, contables y operativos.",
          "Cumplir obligaciones legales, fiscales, administrativas o regulatorias.",
          "Garantizar la seguridad y correcta prestación de nuestros servicios.",
        ]},
        { type: "p", text: "Estas finalidades son necesarias para gestionar la relación contractual y prestar correctamente los servicios solicitados por nuestros clientes." },
      ],
    },
    {
      title: "FINALIDADES SECUNDARIAS",
      content: [
        { type: "p", text: "Cuando resulte permitido por la legislación aplicable, podremos utilizar determinados datos para finalidades secundarias como:" },
        { type: "ul", items: [
          "Envío de promociones.",
          "Ofertas comerciales.",
          "Información sobre nuevos servicios.",
          "Encuestas de satisfacción.",
          "Comunicaciones comerciales.",
          "Análisis estadísticos y mejora de nuestros servicios.",
        ]},
        { type: "p", text: "El usuario podrá solicitar en cualquier momento que sus datos dejen de utilizarse para finalidades comerciales o promocionales enviando un correo electrónico a: contact@rsvcancun.com" },
        { type: "p", text: "La negativa al uso de datos personales para estas finalidades secundarias no afectará la prestación de los servicios contratados." },
      ],
    },
    {
      title: "BASE LEGAL PARA EL TRATAMIENTO",
      content: [
        { type: "p", text: "Dependiendo de las circunstancias y de la legislación aplicable, RSV TRANSFERS podrá tratar los datos personales con fundamento en:" },
        { type: "ul", items: [
          "Ejecución de una relación contractual: cuando la información sea necesaria para gestionar una cotización, reservación, pago o prestar el servicio contratado.",
          "Consentimiento: cuando el usuario proporciona voluntariamente información o acepta determinadas finalidades que requieren consentimiento.",
          "Cumplimiento de obligaciones legales: cuando sea necesario conservar o comunicar información para cumplir obligaciones fiscales, administrativas, judiciales o regulatorias.",
          "Intereses legítimos: cuando resulte permitido por la legislación aplicable, para proteger nuestros servicios, prevenir fraude, mejorar nuestras operaciones o defender nuestros derechos.",
        ]},
        { type: "p", text: "Cuando la legislación aplicable exija consentimiento expreso, RSV TRANSFERS solicitará dicho consentimiento mediante los mecanismos correspondientes." },
      ],
    },
    {
      title: "PROCESAMIENTO DE PAGOS MEDIANTE STRIPE",
      content: [
        { type: "p", text: "RSV TRANSFERS utiliza los servicios de Stripe como proveedor tecnológico para el procesamiento de determinados pagos electrónicos realizados por nuestros clientes." },
        { type: "p", text: "Cuando un usuario realiza un pago mediante Stripe, determinados datos relacionados con el pago son recopilados y procesados directamente por Stripe de acuerdo con sus propias políticas de privacidad, términos de servicio y estándares de seguridad." },
        { type: "p", text: "Dependiendo del método de pago utilizado, Stripe podrá procesar información como:" },
        { type: "ul", items: [
          "Nombre del titular.",
          "Datos de la tarjeta de crédito o débito.",
          "Fecha de vencimiento.",
          "Código de seguridad (CVV), cuando sea requerido durante la operación.",
          "Dirección de facturación, cuando corresponda.",
          "Dirección IP.",
          "Información del dispositivo y navegador.",
          "Importe y moneda de la operación.",
          "Información relacionada con autenticación del pago.",
          "Información utilizada para detección y prevención de fraude.",
        ]},
        { type: "p", text: "RESERVACION CANCUN LLC / RSV TRANSFERS no almacena directamente el número completo de la tarjeta ni el código CVV del cliente cuando estos datos son introducidos y procesados directamente mediante la infraestructura de Stripe." },
        { type: "p", text: "RSV TRANSFERS podrá recibir y conservar determinada información relacionada con la transacción, como el nombre del cliente, importe, moneda, fecha, referencia o identificador de la transacción, estado del pago y otra información necesaria para administrar la reservación, realizar conciliaciones, atender aclaraciones, prevenir fraude y gestionar posibles disputas o contracargos." },
        { type: "p", text: "Stripe podrá utilizar mecanismos adicionales de seguridad y autenticación, incluyendo 3D Secure, herramientas de prevención de fraude y otros sistemas de verificación." },
        { type: "p", text: "El tratamiento de los datos realizado directamente por Stripe se encuentra sujeto adicionalmente a su propia Política de Privacidad, disponible en el sitio web oficial de Stripe." },
      ],
    },
    {
      title: "TERCEROS CON LOS QUE PODEMOS COMPARTIR INFORMACIÓN",
      content: [
        { type: "p", text: "RSV TRANSFERS no vende ni comercializa los datos personales de sus clientes." },
        { type: "p", text: "Para poder administrar reservaciones y prestar nuestros servicios, determinados datos personales podrán ser compartidos únicamente cuando resulte necesario con proveedores que participan en nuestra operación." },
        { type: "p", text: "Entre estos proveedores se encuentra Stripe, utilizado para el procesamiento de pagos electrónicos y servicios relacionados con autenticación, seguridad y prevención de fraude." },
        { type: "p", text: "Asimismo, dependiendo de las características de cada reservación, podremos compartir información estrictamente necesaria con:" },
        { type: "ul", items: [
          "Conductores y operadores asignados al servicio.",
          "Empresas transportistas o proveedores operativos que participen en la prestación del traslado.",
          "Proveedores tecnológicos.",
          "Proveedores de alojamiento e infraestructura web.",
          "Sistemas de reservaciones.",
          "Servicios de correo electrónico y comunicaciones.",
          "Proveedores de prevención de fraude.",
          "Instituciones financieras cuando resulte necesario para gestionar pagos, reembolsos o disputas.",
          "Asesores contables, fiscales o jurídicos.",
          "Autoridades competentes cuando exista una obligación legal.",
        ]},
        { type: "p", text: "Por ejemplo, para realizar correctamente un traslado podremos proporcionar al conductor u operador asignado información como nombre del pasajero, teléfono de contacto, hotel o punto de recogida, destino, número de vuelo y horario." },
        { type: "p", text: "Los terceros únicamente deberán recibir la información razonablemente necesaria para cumplir con la finalidad para la que participan en la prestación del servicio." },
        { type: "p", text: "Cuando los datos sean tratados directamente por Stripe, dicho tratamiento estará sujeto también a las políticas y condiciones de Stripe." },
      ],
    },
    {
      title: "TRANSFERENCIAS INTERNACIONALES",
      content: [
        { type: "p", text: "Debido a que RESERVACION CANCUN LLC está domiciliada en Estados Unidos y los servicios de RSV TRANSFERS pueden prestarse en México, determinados datos personales pueden ser tratados, almacenados o transferidos entre diferentes jurisdicciones." },
        { type: "p", text: "Asimismo, algunos proveedores tecnológicos, financieros o de infraestructura utilizados por RSV TRANSFERS pueden procesar información desde servidores ubicados fuera del país donde se encuentra el usuario." },
        { type: "p", text: "Cuando resulte aplicable, RSV TRANSFERS adoptará medidas razonables para que dichas transferencias se realicen conforme a la legislación correspondiente y para que los receptores de la información mantengan obligaciones adecuadas de confidencialidad y protección." },
      ],
    },
    {
      title: "AUTORIDADES",
      content: [
        { type: "p", text: "Podremos proporcionar datos personales a autoridades administrativas, fiscales, regulatorias o judiciales cuando exista una obligación legal, orden judicial, requerimiento válido de autoridad competente o cuando resulte necesario para ejercer o defender legalmente nuestros derechos." },
      ],
    },
    {
      title: "CONSERVACIÓN DE LOS DATOS",
      content: [
        { type: "p", text: "Los datos personales serán conservados únicamente durante el tiempo razonablemente necesario para:" },
        { type: "ul", items: [
          "Prestar los servicios contratados.",
          "Administrar la relación con el cliente.",
          "Mantener registros de las reservaciones.",
          "Cumplir obligaciones fiscales y contables.",
          "Atender reclamaciones.",
          "Gestionar disputas o contracargos.",
          "Prevenir fraude.",
          "Cumplir obligaciones legales.",
          "Ejercer o defender derechos legales.",
        ]},
        { type: "p", text: "Una vez que la información deje de ser necesaria y hayan concluido los plazos legales, fiscales, contractuales o administrativos aplicables, los datos podrán ser eliminados, anonimizados o bloqueados conforme corresponda." },
      ],
    },
    {
      title: "DERECHOS DEL TITULAR",
      content: [
        { type: "p", text: "El titular de los datos personales podrá ejercer, conforme a la legislación aplicable, sus derechos respecto de la información que mantenemos sobre él." },
        { type: "p", text: "En México estos derechos incluyen los denominados Derechos ARCO:" },
        { type: "sub", text: "Acceso" },
        { type: "p", text: "Solicitar información sobre los datos personales que tenemos y conocer cómo son utilizados." },
        { type: "sub", text: "Rectificación" },
        { type: "p", text: "Solicitar la corrección o actualización de datos personales incorrectos, incompletos o desactualizados." },
        { type: "sub", text: "Cancelación" },
        { type: "p", text: "Solicitar, cuando legalmente proceda, la eliminación o cancelación de sus datos personales." },
        { type: "sub", text: "Oposición" },
        { type: "p", text: "Solicitar que determinados datos personales dejen de utilizarse para ciertas finalidades cuando legalmente proceda." },
        { type: "p", text: "El usuario también podrá solicitar la limitación del uso o divulgación de sus datos personales y, cuando corresponda, revocar el consentimiento previamente otorgado." },
      ],
    },
    {
      title: "PROCEDIMIENTO PARA EJERCER SUS DERECHOS",
      content: [
        { type: "p", text: "Para ejercer sus derechos relacionados con datos personales, el titular podrá enviar una solicitud a: contact@rsvcancun.com" },
        { type: "p", text: "La solicitud deberá incluir información suficiente para permitirnos identificar al titular y localizar la información correspondiente." },
        { type: "p", text: "Podremos solicitar:" },
        { type: "ul", items: [
          "Nombre completo.",
          "Correo electrónico asociado a la reservación.",
          "Número o referencia de reservación, cuando exista.",
          "Descripción clara del derecho que desea ejercer.",
          "Información necesaria para localizar los datos.",
          "Documentación razonablemente necesaria para acreditar la identidad o representación del titular cuando corresponda.",
        ]},
        { type: "p", text: "RSV TRANSFERS analizará y responderá las solicitudes dentro de los plazos establecidos por la legislación aplicable." },
        { type: "p", text: "En determinados casos podremos conservar información aunque se solicite su eliminación cuando exista una obligación legal, fiscal, contractual, administrativa o necesidad legítima de conservarla." },
      ],
    },
    {
      title: "REVOCACIÓN DEL CONSENTIMIENTO",
      content: [
        { type: "p", text: "Cuando el tratamiento esté basado en consentimiento, el usuario podrá solicitar su revocación enviando un correo electrónico a: contact@rsvcancun.com" },
        { type: "p", text: "La revocación no tendrá efectos retroactivos sobre tratamientos realizados legalmente antes de recibir la solicitud." },
        { type: "p", text: "Asimismo, determinados datos podrán continuar siendo tratados cuando resulten necesarios para cumplir obligaciones legales o contractuales." },
      ],
    },
    {
      title: "SEGURIDAD DE LA INFORMACIÓN",
      content: [
        { type: "p", text: "RSV TRANSFERS adopta medidas administrativas, técnicas y organizativas razonables destinadas a proteger los datos personales contra:" },
        { type: "ul", items: [
          "Acceso no autorizado.",
          "Pérdida.",
          "Alteración.",
          "Destrucción.",
          "Divulgación no autorizada.",
          "Uso indebido.",
        ]},
        { type: "p", text: "Estas medidas pueden incluir controles de acceso, restricciones internas de información, sistemas de autenticación, utilización de proveedores tecnológicos especializados y medidas de seguridad aplicables a los sistemas utilizados para gestionar las reservaciones y pagos." },
        { type: "p", text: "No obstante, ningún sistema electrónico, transmisión por Internet o método de almacenamiento puede garantizar seguridad absoluta." },
      ],
    },
    {
      title: "INCIDENTES DE SEGURIDAD",
      content: [
        { type: "p", text: "En caso de producirse una vulneración de seguridad que afecte de forma significativa los derechos de los titulares, RSV TRANSFERS adoptará las medidas razonables necesarias para contener el incidente y realizará las comunicaciones que correspondan conforme a la legislación aplicable." },
      ],
    },
    {
      title: "COOKIES Y TECNOLOGÍAS SIMILARES",
      content: [
        { type: "p", text: "Nuestro sitio web puede utilizar cookies y tecnologías similares para permitir su funcionamiento, recordar determinadas preferencias, analizar el uso del sitio y mejorar la experiencia del usuario." },
        { type: "p", text: "Dependiendo de las herramientas implementadas en el sitio web, algunas cookies pueden ser proporcionadas por terceros." },
        { type: "p", text: "Cuando resulte exigible, el usuario podrá aceptar, rechazar o configurar determinadas categorías de cookies mediante las herramientas disponibles en el sitio." },
        { type: "p", text: "Las cookies estrictamente necesarias podrán utilizarse para permitir funcionalidades esenciales del sitio." },
      ],
    },
    {
      title: "MENORES DE EDAD",
      content: [
        { type: "p", text: "Nuestros servicios están dirigidos principalmente a personas adultas que realizan reservaciones de transportación." },
        { type: "p", text: "RSV TRANSFERS no busca recopilar intencionalmente información directamente de menores de edad para finalidades comerciales." },
        { type: "p", text: "Cuando sea necesario proporcionar información de menores como parte de una reservación familiar, dicha información deberá ser proporcionada por su padre, madre, tutor o adulto responsable y será utilizada únicamente en la medida necesaria para gestionar el servicio." },
      ],
    },
    {
      title: "COMUNICACIONES POR WHATSAPP, TELÉFONO Y CORREO ELECTRÓNICO",
      content: [
        { type: "p", text: "Cuando el usuario proporciona voluntariamente su número telefónico, correo electrónico o utiliza WhatsApp para comunicarse con RSV TRANSFERS, podremos utilizar dicho canal para:" },
        { type: "ul", items: [
          "Responder consultas.",
          "Enviar cotizaciones.",
          "Confirmar reservaciones.",
          "Proporcionar instrucciones para localizar al conductor.",
          "Comunicar cambios.",
          "Brindar asistencia relacionada con el servicio.",
          "Dar seguimiento a una reservación.",
        ]},
        { type: "p", text: "Las comunicaciones comerciales o promocionales podrán ser rechazadas por el usuario en cualquier momento." },
      ],
    },
    {
      title: "ENLACES Y SERVICIOS DE TERCEROS",
      content: [
        { type: "p", text: "Nuestro sitio web puede contener enlaces o integraciones con plataformas externas." },
        { type: "p", text: "RSV TRANSFERS no controla las políticas de privacidad de sitios web o plataformas operadas independientemente por terceros." },
        { type: "p", text: "Recomendamos al usuario consultar las políticas de privacidad de cada proveedor externo antes de proporcionar información directamente a dichas plataformas." },
      ],
    },
    {
      title: "MODIFICACIONES A ESTA POLÍTICA",
      content: [
        { type: "p", text: "RESERVACION CANCUN LLC podrá modificar o actualizar esta Política de Privacidad como consecuencia de cambios:" },
        { type: "ul", items: [
          "Legales.",
          "Regulatorios.",
          "Operativos.",
          "Comerciales.",
          "Tecnológicos.",
          "En nuestros servicios o proveedores.",
        ]},
        { type: "p", text: "La versión actualizada será publicada en nuestro sitio web indicando la fecha de última actualización." },
        { type: "p", text: "Recomendamos consultar periódicamente esta página." },
      ],
    },
    {
      title: "CONTACTO",
      content: [
        { type: "p", text: "Para preguntas relacionadas con esta Política de Privacidad, tratamiento de información personal o ejercicio de derechos relacionados con sus datos, puede comunicarse con:" },
        { type: "ul", items: [
          "RESERVACION CANCUN LLC",
          "Nombre comercial: RSV TRANSFERS",
          "30 N Gould St Ste N, Sheridan, WY 82801, Estados Unidos",
          "Correo electrónico para privacidad y ejercicio de derechos: contact@rsvcancun.com",
          "Teléfono: +52 998 790 7699",
          "Sitio web: rsvcancun.com",
        ]},
      ],
    },
  ],
  copyright: "© 2026 RESERVACION CANCUN LLC – RSV TRANSFERS. Todos los derechos reservados.",
};
